import React from "react";
import { Modal, Button, Text } from "@mantine/core";

const SignatureRequestModal = ({ opened, onClose, onAccept }) => {

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Signature Change Request"
      centered
      size="md"
      overlayProps={{ blur: 5 }}
      
      radius="md"
      withCloseButton={true}
      zIndex={2000}
    >
      <Text size="sm" mb="md" ta={"center"} ff={"Inter"}>
        Staff has requested to change their
        signature.
      </Text>

      <Button
        fullWidth
        color="yellow"
        onClick={onAccept}
        c={"#000"}
        ff={"Inter"}
      >
        Accept
      </Button>
    </Modal>
  );
};

export default SignatureRequestModal;
